"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SmileSolid: function() {
        return SmileSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const SmileSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM7.84986 9.29961C7.84986 8.4988 8.49905 7.84961 9.29986 7.84961C10.1007 7.84961 10.7499 8.4988 10.7499 9.29961C10.7499 10.1004 10.1007 10.7496 9.29986 10.7496C8.49905 10.7496 7.84986 10.1004 7.84986 9.29961ZM13.2503 9.29961C13.2503 8.4988 13.8994 7.84961 14.7003 7.84961C15.5011 7.84961 16.1503 8.4988 16.1503 9.29961C16.1503 10.1004 15.5011 10.7496 14.7003 10.7496C13.8994 10.7496 13.2503 10.1004 13.2503 9.29961ZM17.5005 14.4004C17.7217 13.8943 17.4906 13.3048 16.9846 13.0836C16.4785 12.8625 15.8889 13.0935 15.6678 13.5996C15.0497 15.0144 13.6389 16 12.0002 16C10.3615 16 8.95078 15.0144 8.33262 13.5996C8.1115 13.0935 7.52199 12.8625 7.0159 13.0836C6.50981 13.3048 6.2788 13.8943 6.49992 14.4004C7.42487 16.5174 9.53829 18 12.0002 18C14.4622 18 16.5756 16.5174 17.5005 14.4004Z",
        fill: "currentColor"
    })
}), "SmileSolid");
const _default = SmileSolid;
